"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react["default"].createElement;

var FileNameWrapper = _styledComponents["default"].span.withConfig({
  displayName: "FileNameDisplay__FileNameWrapper",
  componentId: "sc-3r29dt-0"
})(["display:inline-flex;max-width:300px;"]);

var FileNameLabel = _styledComponents["default"].span.withConfig({
  displayName: "FileNameDisplay__FileNameLabel",
  componentId: "sc-3r29dt-1"
})(["flex-grow:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);

var FileNameExtension = _styledComponents["default"].span.withConfig({
  displayName: "FileNameDisplay__FileNameExtension",
  componentId: "sc-3r29dt-2"
})(["flex-shrink:0;"]);

var FileNameDisplay = function FileNameDisplay(_ref) {
  var _ref$filename = _ref.filename,
      filename = _ref$filename === void 0 ? '' : _ref$filename;
  var extensionPosition = filename.lastIndexOf('.');
  var name = filename.substr(0, extensionPosition);
  var extension = filename.substr(extensionPosition);
  return __jsx(FileNameWrapper, {
    title: filename
  }, __jsx(FileNameLabel, null, name), __jsx(FileNameExtension, null, extension));
};

var _default = FileNameDisplay;
exports["default"] = _default;